import { useEffect, useState, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../slices/index';
import * as User from '../slices/userSlice';
import * as Cases from '../slices/casesSlice';
import * as UI from '../slices/uiSlice';

interface ProtectedRouteProps {
    children: ReactNode;
}

type AuthStatus = 'pending' | 'authenticated' | 'unauthenticated';

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
    const dispatch = useAppDispatch();
    const user = useAppSelector(state => state.user);
    const cases = useAppSelector(state => state.cases);
    const [authStatus, setAuthStatus] = useState<AuthStatus>(
        user.token ? 'authenticated' : 'pending'
    );

    useEffect(() => {
        const loadCasesData = (userId: string, securityToken: string) => {
            dispatch(Cases.setLoaded(false));
            dispatch(Cases.setLoading(true));
            dispatch(Cases.getCases({ user: userId, security: securityToken }) as any)
                .then((result: any) => {
                    dispatch(Cases.searchCases({ searchStr: cases.searchStr, isWishlisted: false }));
                    try {
                        const action = JSON.parse(result.payload as string);
                        if (action.status !== 'OK') {
                            dispatch(UI.setError({ visible: true, message: 'Load Cases Failed' }));
                        }
                    } catch (e) {
                        dispatch(UI.setError({ visible: true, message: 'Load Cases Failed' }));
                    }
                });
        };

        if (user.token) {
            if (!cases.isLoaded) {
                loadCasesData(user.id, user.token);
            }
            return;
        }

        dispatch(User.getProfile() as any).then((r: any) => {
            try {
                const rp = JSON.parse(r?.payload);
                if (rp.status === 'OK') {
                    dispatch(Cases.setUser(rp.refer));
                    loadCasesData(
                        rp.type === 'developer' ? rp.developers?.[0]?.developerid : rp.introducer?.introducerid,
                        rp.token
                    );
                    setAuthStatus('authenticated');
                } else {
                    setAuthStatus('unauthenticated');
                }
            } catch {
                setAuthStatus('unauthenticated');
            }
        });
    }, []);

    if (authStatus === 'unauthenticated') {
        return <Navigate to="/" replace />;
    }
    if (authStatus === 'pending') {
        return (
            <div className="centered" style={{ display: 'flex', flexDirection: 'column' }}>
                <img src={require('../assets/bricks.gif')} alt='Loading' style={{ width: 67, height: 34 }} />
            </div>
        );
    }
    return <>{children}</>;
};

export default ProtectedRoute;